export const environment = {
  production: false,
  // apiUrl: 'https://api.runparts.importer.stg.vehitech.co.il/api/v1/',
  apiUrl: 'https://api.runparts.starter.co.il/api/v1/',
  partstreamApiURL: 'https://partstream.newprod.vehitech.co.il',
  partstreamApiSourceId: 'runparts',
  siteUrl: 'https://runparts-v2.importer.stg.vehitech.co.il/',
};
